export const BASIC_COURSE_SOURCE_ALIASES = Object.freeze({
  MaturaCosineGivenValueOpenTask: "MaturaBasic_TriangleSideTwoLengthsCosineLawClosed",
  MaturaBarChartPercentageComparisonOpenTask: "MaturaBarChartStatsOpenTask",
  MaturaGeometricEdgeRatioOpenTask: "MaturaCuboidGeoSequenceVolumeOpenTask",
});
